// Orange house pin colors from the design mockup.
const PIN_COLOR = '#ed6214';

// Orange house pin from the design mockup.
export const LOCATION_PIN_ICON_URL = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" width="44" height="56" viewBox="0 0 44 56">
    <path d="M22 54C22 54 3 33 3 21C3 10.5 11.5 2 22 2C32.5 2 41 10.5 41 21C41 33 22 54 22 54Z" fill="${PIN_COLOR}" stroke="#ffffff" stroke-width="2"/>
    <path d="M22 11L11.5 20H15V30H19.5V23.5H24.5V30H29V20H32.5L22 11Z" fill="#ffffff"/>
  </svg>`
)}`;
